if (!customElements.get('td-frontrow-sticker')) {
  const BASE_WIDTH = 437;

  class TdFrontrowSticker extends HTMLElement {
    connectedCallback() {
      this.resizeObserver = new ResizeObserver(() => this.updateScale());
      this.resizeObserver.observe(this);
      this.updateScale();
    }

    disconnectedCallback() {
      this.resizeObserver?.disconnect();
    }

    updateScale() {
      const scale = Math.min(1, this.clientWidth / BASE_WIDTH);
      this.style.setProperty('--td-fr-scale', `scale(${scale})`);
    }
  }

  customElements.define('td-frontrow-sticker', TdFrontrowSticker);
}
